module.exports = "/images/vendor/flag-icon-css/flags/1x1/il.svg?c36a011de460eb2d3b8c5674b9496d45";